import { render } from "./CampaignsCount.vue?vue&type=template&id=c56fb79c&scoped=true"
import script from "./CampaignsCount.vue?vue&type=script&lang=js"
export * from "./CampaignsCount.vue?vue&type=script&lang=js"

import "./CampaignsCount.vue?vue&type=style&index=0&id=c56fb79c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56fb79c"]])

export default __exports__